import { useQuery } from "react-query"
import { getFollowersPaged } from "@requests/userBands"

export function useFollowersPaged(bandId: number, page: number, perPage = 40) {
  return useQuery(
    ["followers_paged", bandId, page, perPage],
    () => getFollowersPaged(bandId, page, perPage),
    { keepPreviousData: true },
  )
}
